export default "https://cdn-static.gokick.com/assets/78cedee4a9b459fbef408ae219aa3203e6c5e731/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";